import React from 'react';

import styles from './ContentInfoBox.scss';

function ContentInfoBox({
  headline,
  body,
  extraClass,
  actionButton,
  children,
}) {
  body = body && body.substring(0, 3) === '<p>' ? body : `<p>${body}</p>`;

  return (
    <div className={`ContentInfoBox${extraClass || ''}`}>
      <header className="ContentInfoBox__header">
        <h4 className="ContentInfoBox__headline">{headline}</h4>
      </header>
      {actionButton}
      {children ? (
        <div className="ContentInfoBox__details">{children}</div>
      ) : (
        <div
          className="ContentInfoBox__details"
          dangerouslySetInnerHTML={{ __html: body }}
        />
      )}
    </div>
  );
}

export default ContentInfoBox;
